import { type TFunction } from 'i18next';

/**
 * Translates a bet/selection name, mirroring the odds-grid `getTranslatedBetTitle` mechanism:
 * the bet name is used directly as a translation key (the provided `t` should be bound to the
 * sport/label/bettype namespaces by the caller), and the line — a handicap/total like "+3" or
 * "7.5" — is appended untranslated. Falls back to the raw name when no translation exists.
 */
export const getTranslatedBetName = (name: string, line: string | undefined, t: TFunction): string => {
  const translatedName = t(name);
  return line ? `${translatedName} ${line}`.trim() : translatedName;
};
